import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["menu", "openIcon", "closeIcon", "dropdown"]

  toggle() {
    const isOpen = !this.menuTarget.classList.contains("hidden")
    if (isOpen) {
      this.close()
    } else {
      this.open()
    }
  }

  open() {
    this.menuTarget.classList.remove("hidden")
    this.openIconTarget.classList.add("hidden")
    this.closeIconTarget.classList.remove("hidden")
    document.body.classList.add("overflow-hidden")
  }

  close() {
    this.menuTarget.classList.add("hidden")
    this.openIconTarget.classList.remove("hidden")
    this.closeIconTarget.classList.add("hidden")
    document.body.classList.remove("overflow-hidden")
  }

  toggleDropdown(event) {
    event.stopPropagation()
    if (!this.hasDropdownTarget) return

    const isOpen = !this.dropdownTarget.classList.contains("hidden")
    if (isOpen) {
      this.closeDropdown()
    } else {
      this.openDropdown()
    }
  }

  openDropdown() {
    this.dropdownTarget.classList.remove("hidden")
    this._outsideClickHandler = (event) => {
      if (!this.dropdownTarget.contains(event.target) && !event.target.closest("[data-action*='toggleDropdown']")) {
        this.closeDropdown()
      }
    }
    document.addEventListener("click", this._outsideClickHandler)
  }

  closeDropdown() {
    if (!this.hasDropdownTarget) return
    this.dropdownTarget.classList.add("hidden")
    if (this._outsideClickHandler) {
      document.removeEventListener("click", this._outsideClickHandler)
      this._outsideClickHandler = null
    }
  }

  disconnect() {
    if (this._outsideClickHandler) {
      document.removeEventListener("click", this._outsideClickHandler)
    }
  }
}
